import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postPaymentMethod } from '../../../../actions';
import { PAYMENT_METHOD_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import PaymentMethodForm from './PaymentMethodForm';

const NewPaymentMethod = ({ breadcrumbs, dispatchpostPaymentMethod }) => {
  const onSubmit = (formValues) =>
    dispatchpostPaymentMethod({
      ...formValues,
      transactionCode: formValues.transactionCode.value
    });

  const content = <PaymentMethodForm onSubmit={onSubmit} />;
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Método de Pago"
      subtitle="Crear una nueva método de pago."
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchpostPaymentMethod: postPaymentMethod,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Métodos de Pago',
      href: PAYMENT_METHOD_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

NewPaymentMethod.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchpostPaymentMethod: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPaymentMethod);
